import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import { userContext } from '../../UserContext';

function LoginButton() {
    const [buttonClicked, clickButton] = useState(false);
    const [usernameInputVal, setUsernameInput] = useState('');
    const [passwordInputVal, setPasswordInput] = useState('');
    const {setUser} = useContext(userContext)
    const navigate = useNavigate()
    
    const handleUsernameInputChange = (event) => {
        setUsernameInput(event.target.value);
    };
    const handlePasswordInputChange = (event) => {
        setPasswordInput(event.target.value);
    };

    const usernameInput = usernameInputVal
    const passwordInput = passwordInputVal

    useEffect(() => {
        if (buttonClicked) {
            fetch("https://mv.cylee.xyz/authUser", {
                body: 
                    JSON.stringify({
                        "username": usernameInput,
                        "password": passwordInput
                    }),
                method: "POST"
            }).then(response => {
                if(!response.ok) {
                    clickButton(false)
                    alert("Username/Password may be wrong! Please try again")
                } else {
                    response.json().then((result) => {
                        setUser(result)
                        navigate("/GenerateReport")
                    })
                }
            })

            clickButton(false)
        }
    }, [buttonClicked]);

    const handleLogin = () => {
        clickButton(true)
    };

    return(
        <section className='Login'>
            <form name='login' className='login' onSubmit={(e) => {e.preventDefault(); handleLogin()}}>
                <input type='text' value={usernameInputVal} onChange={handleUsernameInputChange} placeholder='Username'></input>
                <br />
                <input type='password' value={passwordInputVal} onChange={handlePasswordInputChange} placeholder='Password'></input>
                <br />
                <button type='submit'>Login</button>
            </form>
        </section>
    )
}

export default LoginButton